import styled from '@emotion/styled'

export const OutputContainer = styled('div')`
  & .output-container {
    font-size: 12px;
    margin-top: 4px;
  }
`

export const PowerNetLevelValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  .hoverable-info-icon {
    display: inline-flex;
    align-items: center;
  }

  svg {
    margin-left: 0 !important;
  }

  .chec-icon {
    width: 14px !important;
    height: 14px !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
  }
`
